"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addPerformanceObserver = void 0;
const requestIdleCallbackOrTimeout_1 = require("./requestIdleCallbackOrTimeout");
const addPerformanceObserver = (reporterFn, entryTypes) => {
    if (typeof PerformanceObserver !== 'undefined') {
        requestIdleCallbackOrTimeout_1.requestIdleCallbackOrTimeout(() => {
            const observer = new PerformanceObserver(reporterFn);
            observer.observe({
                entryTypes: entryTypes,
            });
        });
    }
};
exports.addPerformanceObserver = addPerformanceObserver;
//# sourceMappingURL=PerformanceObserver.js.map